import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { CommonDeleteButton, CommonEditButton, ConfirmPopup, renderInsCorpDetails } from '../../../../../Components/Common Components/CommonComponents';
import {
    Box, Button, TextField, Tooltip, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Autocomplete, Typography,
    IconButton,
    Dialog,
    Grid,
    FormHelperText,
    Popover,
    Divider
} from '@mui/material';
import Loader from '../../../../../Components/Loader';
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg';
import { Colors } from '../../../../../Styles/Colors';
import { ImagePaths } from '../../../../../Utility/ImagePaths';
import RestAPIService from '../../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../../Utility/API/Serviceurls';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { localGetItem } from '../../../../../Utility/Services/CacheProviderService';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import dayjs from 'dayjs';
import { AmountFormat, CheckAccessFunc, GetInvestigationName } from '../../../../../Components/CommonFunctions/CommonFunctions';
import CommonValidation from '../../../../../Components/CommonFunctions/CommonValidation';
import { CurrencySymbol } from '../../../../../Utility/Constants';
import LineItemRemarksButton from '../../../../../Components/Common Components/LineItemRemarksButton';
import { isLineItemRemarksEnabled, clampLineItemRemarks, isMandatoryConcessionRemarksEnabled } from '../../../../../Utility/lineItemRemarksUtils';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';


const STYLES = {
    FONT_SIZE_LOW_2: "14px",
    FONT_SIZE_LOW_3: "12px",
    FONT_WEIGHT: "bold"
};

const COMMON_STYLES = {
    HEIGHT: '4.5dvh',
    FONT_SIZE_XS: '0.7rem',
    FONT_SIZE_SM: '0.8rem',
    FONT_SIZE_MD: '0.85rem',
    FONT_SIZE_L: '0.9rem',
    FONT_WEIGHT: 600
}

const LabCreateOrder = () => {
    const [formState, setformState] = useState({
        orderList: [],
        dupOrderList: '[]',
        billDocSugg: [],
        serviceSugg: [],
        tempPackSugg: [],
        selected_bill_doc: null,
        selected_service: null,
        selected_temp_pack: null,
        service_data: {
            rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
            doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
            hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
            interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
            service_code: '', service_head_code: '', edit_unit: false, edit_amount: false,
            edit_discount: false, doctor_name: '', doctor_id: '', start_time: '',
            end_time: '', doc_discount_amt: '', doc_discount_percent: '',
            hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
            concession_percent: '', gst_percent: 0, hours: '', minutes: '',
            concession_comments: '', service_details_id: '', doctor_id: '',
            review_days: '', review_count: '', charge_id: '',
            gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
            taxable_amount: '', sub_total_amount: '', round_off: '',
            received_amount: '', net_amount: '', concession_percent_w_r: '',
            doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
            doctor_percent_w_r: '', hospital_percent_w_r: '',
            module_type: '', start_date: new Date(), end_date: null, is_hospital: false,
            service_head_id: null, doctor_id: '', op_order_number: '',
            id: null
        },
        isEdit: false,
        selectedIndex: null,
    });
    const [PatientDetails, setPatientDetails] = useState({});
    const [PatientSearchList, setPatientSearchList] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    let loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    const [loginInfo, setLoginInfo] = useState(loggedInUserInfo);
    const AmountViewAccess = ((!loggedInUserInfo?.is_user && loggedInUserInfo?.is_doctor == false) || (loggedInUserInfo?.permission_access?.common?.show_order_amounts) || (loggedInUserInfo?.is_doctor))

    let history = useHistory()
    const [IsWarning, setIsWarning] = useState('');
    const [tempDup, settempDup] = useState([]);
    const [duplicateIds, setDuplicateIds] = useState([]);
    const [openPopup, setOpenPopup] = useState(false)
    const [concessionRemarksOpen, setConcessionRemarksOpen] = useState(false)
    const [popupValues, setPopupValues] = useState({})
    const [searchKey, setsearchKey] = useState('')
    const [ServiceCount, setServiceCount] = useState(false)
    const [insuToolOpen, setInsuToolOpen] = useState(false);
    const [membershipDetails, setMembershipDetails] = useState(null)
    const [dialogOpen, setDialogOpen] = useState(false)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const billingContainerRef = useRef(null);

    const userAccess = CheckAccessFunc("Radiology", "Order", 'Create Order', null, "Tab");

    useEffect(() => {
        const ip_patient_id = history?.location?.state?.ipListData?.patient_id;

        getDoctorList()
        getTemplateList(ip_patient_id)
        if (ip_patient_id) {
            getPatientDetails(ip_patient_id);
        }
        // Hide tooltip after 2 seconds
        const hideTooltip = setTimeout(() => {
            setInsuToolOpen(false);
        }, 2000);

        return () => {
            clearTimeout(hideTooltip);
        };
    }, [])

    useEffect(() => {
        if (history?.location?.state?.Patient_ID && formState?.billDocSugg?.length > 0) {
            let data = history?.location?.state?.Patient_ID
            setPatientDetails(data)
            const ip_patient_id = data?.patient_id;
            if (ip_patient_id) {
                getPatientDetails(ip_patient_id);
            }
            getTemplateList(data?.patient_id)
            const matchedDoctor = formState?.billDocSugg.find(doc => doc?.doctor_id === data?.doctor_id);
            setformState((prev) => ({
                ...prev, selected_bill_doc: matchedDoctor
            }))
        }
    }, [history?.location?.state?.Patient_ID, formState?.billDocSugg]);

    useEffect(() => {
        if (formState?.selected_bill_doc) {
            getServiceListData()
        } else {
            setformState((prev) => ({ ...prev, serviceSugg: [] }))
        }
    }, [formState?.selected_bill_doc]);

    useEffect(() => {
        if (formState?.isEdit) {
            billingContainerRef.current?.focus();
        }
    }, [formState?.isEdit]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key !== 'Enter') return;

            const activeEl = document.activeElement;

            // Either container OR any child
            const isInsideBilling =
                billingContainerRef.current === activeEl ||
                billingContainerRef.current?.contains(activeEl);

            if (!isInsideBilling) return;

            // Autocomplete dropdown open
            if (document.querySelector('[role="listbox"]')) return;

            const isAddDisabled = (!formState.selected_bill_doc || !formState.selected_service || !userAccess?.editAccess);

            if (isAddDisabled) return;

            e.preventDefault();
            e.stopPropagation();
            onAddHandler();
        };

        document.addEventListener('keydown', handleKeyDown, true);

        return () =>
            document.removeEventListener('keydown', handleKeyDown, true);
    }, [formState]);

    const getServiceListData = (searchKey = '') => {
        try {
            const getFormattedPatientType = (type) => {
                const mapping = {
                    old_patient: "Old Patient",
                    new_patient: "New Patient",
                    review_patient: "Review Patient"
                };

                return mapping[type] || type;
            };
            setIsLoader(true);
            let patientType = getFormattedPatientType(PatientDetails?.patient__patient_type || PatientDetails?.patient_type || '');
            let module_type = loginInfo?.module_name === 'Radiology' ? 'RADIOLOGY' : loginInfo?.module_name === "Investigation" ? GetInvestigationName() : 'LAB';
            let AdmisId =  PatientDetails?.id || PatientDetails?.ip_admission_id || ""
            RestAPIService.getAll(
                Serviceurls.NEW_BILLING_OP_SERVICE_GET +
                '?patient_type=' + patientType +
                '&module_type=' + module_type +
                '&ward_id=' + '' +
                '&doctor_id=' + formState.selected_bill_doc?.doctor_id +
                '&search_key=' + searchKey +
                '&patient_id=' + (PatientDetails?.patient_id || '') +
                (AdmisId ? `&ip_admission_id=${AdmisId}` : "")
            ).then((response) => {
                if (response?.data?.status === 'success') {
                    setIsLoader(false);
                    setformState((prev) => ({ ...prev, serviceSugg: response?.data?.data }))
                    if (!ServiceCount) {
                        setServiceCount(response.data.service_length > 1000 ? true : false)
                    }
                }
            }).catch((error) => {
                setIsLoader(false);
                if (error?.response?.data?.message) {
                    errorMessage(error?.response?.data?.message)
                } else {
                    errorMessage(error.message)
                }
            })
        } catch (error) {
            setIsLoader(false);
            errorMessage(error.message)
        }
    }

    const getTemplateList = (ip_patient_id) => {
        try {
            setIsLoader(true);
            RestAPIService.getAll(Serviceurls.NEW_BILLING_OP_TEMPLATE_LIST + `?module_type=${loginInfo?.module_name === 'Laboratory' ? 'LAB' : loginInfo?.module_name === "Investigation" ? GetInvestigationName() : loginInfo?.module_name}&patient_id=${ip_patient_id}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setIsLoader(false);
                        setformState((prev) => ({ ...prev, tempPackSugg: response?.data?.data }))
                    }
                }).catch((error) => {
                    setIsLoader(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setIsLoader(false);
            errorMessage(error.message)
        }
    }

    const getDoctorList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setformState((prev) => ({ ...prev, billDocSugg: response?.data?.data }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getPatientDetails = (patient_id) => {
        try {
            RestAPIService.getAll(Serviceurls.LAB_PATIENT_GET + '?patient_id=' + patient_id + '&branch_id=' + (localGetItem('BranchId') || ''))
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        let data = response?.data?.data
                        setPatientDetails(data)
                        setInsuToolOpen(true);
                        const matchedDoctor = formState?.billDocSugg.find(doc => doc.doctor_id === data?.doctor_id);
                        setformState((prev) => ({
                            ...prev, selected_bill_doc: matchedDoctor
                        }))
                        if(response?.data?.data?.is_memberships){
                            setMembershipDetails({
                                is_memberships: response?.data?.data?.is_memberships,
                                membership_expair_date: response?.data?.data?.membership_expair_date,
                                membership_expiry_count: response?.data?.data?.membership_expiry_count,
                                membership_no_of_visit: response?.data?.data?.membership_no_of_visit,
                                membership_total_no_of_visit: response?.data?.data?.membership_total_no_of_visit,
                                membership_type: response?.data?.data?.membership_type,
                                membership_validity: response?.data?.data?.membership_validity,
                            })
                        }
                    }
                }).catch(error => {
                    errorMessage(error?.response?.data?.message || errorMessage(error.message));
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const LoaderFunction = (key) => {
        setIsLoader(key);
    };

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    };

    const errorMessage = (msg) => {
        seterrorMsgText(msg);
        seterrorMsg(true);
    };

    const successMessage = (msg) => {
        setsuccessMsgText(msg);
        setsuccessMsg(true);
    };

    const netAmount = useMemo(() => {
        return formState?.orderList?.reduce(
            (acc, item) => acc + Number(item?.total_with_discount || 0),
            0
        );
    }, [formState.orderList]);

    const postOrderDetails = () => {
        try {
            if (formState.orderList?.length === 0) {
                errorMessage("The Order List Is Empty. Please Add Services.");
                return;
            }
            let data = {
                patient_id: PatientDetails?.patient_id,
                doctor_id: formState?.selected_bill_doc?.doctor_id,
                order_date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                order_status: 'Accepted',
                order_amount: formState?.orderList?.reduce((acc, item) => acc + (item?.total_with_discount || 0), 0),
                ordered_from: loginInfo?.module_name === 'Radiology' ? 'RADIOLOGY' : loginInfo?.module_name === "Investigation" ? GetInvestigationName() : 'LAB',
                is_direct_bill: false,
                is_ip: true,
                clinic_id: parseInt(loginInfo?.clinic_id) || null,
                ip_admission_id: PatientDetails?.id || PatientDetails?.ip_admission_id || null,
                order_line_items: formState?.orderList?.map((item) => ({
                    bill_doctor_id: item?.doctor_id,
                    service_head_id: item?.service_head_id,
                    service_details_id: item?.service_details_id,
                    service_charge_id: item?.charge_id,
                    order_line_status: 'Accepted',
                    is_processed: true,
                    gst_percent: item?.gst_percent || 0,
                    unit: item?.unit || 1,
                    unit_type: item?.unit_type || 'Nos',
                    interval_time: item?.interval_time || null,
                    interval_amount: item?.interval_amount || 0,
                    doctor_share_percent: item?.doctor_percent || 0,
                    hospital_share_percent: item?.hospital_percent || 0,
                    old_doctor_fee: item?.old_doctor_amt || 0,
                    old_hospital_fee: item?.old_hospital_amt || 0,
                    new_doctor_fee: item?.doctor_amt || 0,
                    new_hospital_fee: item?.hospital_amt || 0,
                    start_time: null,
                    end_time: null,
                    total_amount: item?.total_with_discount || 0,
                    sub_total_amount: item?.sub_total_amount || 0,
                    rate_per_unit: item?.rate_per_unit || 0,
                    approved_date: null,
                    cancel_date: null,
                    is_active: true,
                    service_code: item.sevice_code,
                    service_head_code: item.service_head_code,
                    service_head_name: item.service_head_name,
                    service_name: item.service_name,
                    discount_amount: +item?.concession_amt || 0,
                    discount_percentage: +item?.concession_percent || 0,
                    billing_display: item?.billing_display || null,
                    is_membership_discount_applied: item?.membership_discount_percentage ?? false,
                    module_type: item?.module_type || (loginInfo?.module_name === 'Radiology' ? 'RADIOLOGY' : loginInfo?.module_name === "Investigation" ? GetInvestigationName() : 'LAB'),
                    ...(item.package_id ? {
                        package_detail_id: item.package_detail_id,
                        package_name: item.package_name,
                    } : null),
                    remarks: clampLineItemRemarks(item?.line_item_remarks != null ? String(item.line_item_remarks) : ''),
                    individual_concession_comments: (+item?.concession_amt || 0) > 0 ? (item?.individual_concession_comments || '') : '',
                }))
            };

            setIsLoader(true);

            RestAPIService.create(data, Serviceurls.BILLING_CREATE_ORDER_LAB)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message);
                        setIsLoader(false);
                        handleClear();
                    }
                }).catch(e => {
                    setIsLoader(false);
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message);
                    } else {
                        errorMessage(e.message);
                    }
                });
        } catch (e) {
            setIsLoader(false);
            errorMessage(e.message);
        }
    }

    const renderConcessionRemarksDialog = () => {
        if (!concessionRemarksOpen) return null;
        const lineOn = isLineItemRemarksEnabled();
        const concOn = isMandatoryConcessionRemarksEnabled();
        const row = formState?.service_data || {};
        const rowHasConcession = (+row?.concession_amt || 0) > 0;
        const mode = lineOn && concOn ? 'both' : (lineOn ? 'line' : 'concession');
        const dlgTitle = mode === 'both' ? 'Line Item & Concession Remarks'
            : (mode === 'line' ? 'Line Item Remarks' : 'Concession Remarks');
        return (
            <LineItemRemarksButton
                enabled={lineOn || concOn}
                hideIcon
                open={concessionRemarksOpen}
                onClose={() => setConcessionRemarksOpen(false)}
                value={mode === 'concession'
                    ? (rowHasConcession ? (row.individual_concession_comments || '') : '')
                    : (row.line_item_remarks || row.remarks || '')}
                dialogTitle={dlgTitle}
                fieldLabel={mode === 'concession' ? 'Concession Remarks' : 'Line Item Remarks'}
                required={mode === 'concession' && rowHasConcession}
                secondField={mode === 'both' ? {
                    label: 'Concession Remarks',
                    placeholder: 'Enter remarks for concession',
                    value: rowHasConcession ? (row.individual_concession_comments || '') : '',
                    required: rowHasConcession,
                } : undefined}
                onSave={(primary, second) => {
                    const pv = clampLineItemRemarks(primary);
                    const next = { ...row };
                    if (mode === 'concession') {
                        next.individual_concession_comments = pv;
                    } else if (mode === 'line') {
                        next.line_item_remarks = pv;
                        next.remarks = pv;
                    } else {
                        const sv = clampLineItemRemarks(second || '');
                        next.line_item_remarks = pv;
                        next.remarks = pv;
                        next.individual_concession_comments = sv;
                    }
                    setformState((prev) => ({ ...prev, service_data: next }));
                    setConcessionRemarksOpen(false);
                    onAddHandler(next);
                }}
            />
        );
    }

    const PopoverBox = () => {
        return (
            <Popover
                open={dialogOpen}
                anchorEl={anchorEl}
                onClose={popClose}
                anchorReference="anchorPosition"
                anchorPosition={{ top: 0, left: 0 }}
                slotProps={{
                    paper: {
                        sx: {
                            width: '27vw',
                            borderRadius: '0.4vw',
                            padding: '1rem',
                            boxShadow: '0px 0.2vw 1vw rgba(0,0,0,0.1)',
                            position: 'fixed !important',
                            top: loginInfo?.module_name === 'Radiology' ? '14vw !important' : '17vw !important',
                            left: '50vw !important',
                            boxShadow: '0vw 0.4vw 1.5vw rgba(0, 0, 0, 0.15)',
                            border: '1px solid rgba(0, 0, 0, 0.05)',
                        }
                    }
                }}
            >
                <Box display='flex' justifyContent='space-between' alignItems='center' mb='0.5rem'>
                    <Typography fontSize='1rem' fontWeight={600}>Membership Card</Typography>
                    {membershipDetails?.membership_expiry_count && (
                        <Box sx={{
                            backgroundColor: '#fee2e2',
                            color: '#b91c1c',
                            padding: '2px 12px',
                            borderRadius: '20px',
                            fontSize: '0.75rem',
                            border: '1px solid #fecaca'
                        }}
                        >
                            {`Expires in ${membershipDetails?.membership_expiry_count} ${Number(membershipDetails?.membership_expiry_count) === 1 ? 'Day' : 'Days'}`}
                        </Box>
                    )}
                </Box>
                <Divider sx={{ mb: 2 }} />
                <Grid container spacing={1.5} sx={{ width: '26vw' }}>
                    <Grid item sx={{ flex: '0 0 30%' }}>
                        <Typography color="textSecondary" fontSize="0.9rem">Package Name</Typography>
                    </Grid>
                    <Grid item xs={8.4}>
                        <Tooltip title={membershipDetails?.membership_type || '-'} arrow placement="top">
                            <Typography fontWeight={600} fontSize="0.9rem">{`: ${membershipDetails?.membership_type ?
                                membershipDetails?.membership_type.length > 25
                                    ? membershipDetails?.membership_type.slice(0, 35) + '...'
                                    : membershipDetails?.membership_type
                                : '-'}`}</Typography>
                        </Tooltip>
                    </Grid>

                    <Grid item sx={{ flex: '0 0 30%' }} >
                        <Typography color="textSecondary" fontSize="0.9rem">Validity Period</Typography>
                    </Grid>
                    <Grid item xs={8.4}>
                        <Typography fontWeight={600} fontSize="0.9rem"> {`: ${membershipDetails?.membership_validity || '-'}`} </Typography>
                    </Grid>
                    <Grid item sx={{ flex: '0 0 30%' }}>
                        <Typography color="textSecondary" fontSize="0.9rem">No.of Visit</Typography>
                    </Grid>
                    <Grid item xs={8.4}>
                        <Typography fontWeight={600} fontSize="0.9rem">{`: ${membershipDetails?.membership_no_of_visit || '0'} / ${membershipDetails?.membership_total_no_of_visit || '-'}`}</Typography>
                    </Grid>
                </Grid>
            </Popover>
        )
    }


    const renderPatientCard = (item, type) => {
        try {
            let gender = item?.gender === 'm' ? 'M' : item?.gender === 'f' ? 'F' : 'T'
            let patientName = `${item?.patient_name || item?.first_name} ${item?.patient_age}/${gender}`
            let uhidMob = `${item.patient_account_number} | ${item?.patient_mobile_number || item?.mobile_number}`
            let profile = item?.photo_url ? item?.photo_url : gender === 'M' ? ImagePaths.Male.default : ImagePaths.Female.default
            let borderColor = item?.patient__patient_type === 'New Patient' ? '#F1584A' : item?.patient__patient_type === 'Review Patient' ? '#29B6F6' : '#800080'
            let consultantName = item?.doctor_name || '-'
            return (
                <Box component={'div'} sx={{ backgroundColor: "white", marginLeft: '0.5vw', boxShadow: '0 1px 4px rgba(42, 40, 40, 0.1)' }}>
                    {type === 'consultant' ?
                        <Box component={'div'} sx={{ width: "13vw" }}>
                            <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'flex-start'} >
                                <Box component={'div'} mr={'0.5rem'} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box component={'img'} src={ImagePaths.Doctor_Icon.default} height={'5dvh'} width={'2.3dvw'} />
                                </Box>
                                <Box component={'div'}>
                                    <Typography fontSize={STYLES.FONT_SIZE_LOW_3} color={Colors.grayShade}>{'Consultant Name'}</Typography>
                                    {consultantName ? consultantName?.length > 30 ?
                                        <Tooltip placement='top' title={consultantName}><Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={600}>{consultantName?.slice(0, 30) + '...'}</Typography></Tooltip> :
                                        <Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={600}>{consultantName}</Typography> : '-'}
                                </Box>
                            </Box>
                        </Box> :
                        <Box component={'div'} sx={{ width: "17.3vw" }}>
                            <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'flex-start'} >
                                <Box component={'div'} mr={'0.5rem'} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box component={'img'} src={profile} height={'5dvh'} width={'2.3dvw'} borderRadius={'50%'} border={`2px solid ${borderColor}`} />
                                </Box>
                                <Box component={'div'}>
                                    {patientName ? patientName?.length > 25 ?
                                        <Tooltip placement='top' title={patientName}><Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT} sx={{ whiteSpace: "nowrap" }}>{patientName?.slice(0, 23) + '...'}{renderInsCorpDetails(item, insuToolOpen)}</Typography></Tooltip> :
                                        <Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT} sx={{ whiteSpace: "nowrap" }}>{patientName}{renderInsCorpDetails(item, insuToolOpen)}</Typography> : '-'}
                                    {uhidMob ? uhidMob?.length > 30 ?
                                        <Tooltip placement='top' title={uhidMob}><Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{uhidMob?.slice(0, 30) + '...'}</Typography></Tooltip> :
                                        <Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{uhidMob}</Typography> : '-'}
                                </Box>
                            </Box>
                        </Box>}
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onClickUnitHandler = (type) => {
        try {
            setformState((prev) => {
                const updatedServiceData = { ...prev.service_data };
                switch (type) {
                    case 'increase':
                        updatedServiceData.unit++;
                        break;
                    case 'decrease':
                        updatedServiceData.unit = Math.max(0, updatedServiceData.unit - 1);
                        break;
                }

                let total = updatedServiceData.unit * updatedServiceData.rate_per_unit
                updatedServiceData.total_amt = total;
                updatedServiceData.concession_amt = CommonValidation.getDiscountAmountWithRound(updatedServiceData.concession_percent, total)

                return { ...prev, service_data: updatedServiceData };
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }
    const getInlineServiceListData = (doc_id, ward_id, service_id, index) => {
        try {
            let moduleType = formState.patientData?.appointment_id ? 'OP' : formState.patientData?.id ? 'IP' : null
            const getFormattedPatientType = (type) => {
                const mapping = {
                    old_patient: "Old Patient",
                    new_patient: "New Patient",
                    review_patient: "Review Patient"
                };
                return mapping[type] || type;
            };
            setIsLoader(true);
            let patientType = getFormattedPatientType(formState.patientData?.patient_type || '');
            let AdmisId =  PatientDetails?.id || PatientDetails?.ip_admission_id || ""
            RestAPIService.getAll(
                Serviceurls.NEW_BILLING_OP_SERVICE_GET +
                '?patient_type=' + patientType +
                '&module_type=' + moduleType +
                '&ward_id=' + (ward_id || '') +
                '&doctor_id=' + doc_id + '&service_id=' + service_id +
                '&patient_id=' + (formState.patientData.patient_id || '') +
                (AdmisId ? `&ip_admission_id=${AdmisId}` : "")
            ).then((response) => {
                if (response?.data?.status === 'success') {
                    const element = response.data.data[0];
                    setIsLoader(false);
                    setformState((prev) => {
                        const updatedOrderList = [...prev.orderList];
                        let amount = element?.service_charge;
                        updatedOrderList[index] = {
                            ...updatedOrderList[index],
                            rate_per_unit: amount, unit: element.unit,
                            unit_type: element.unit_type, total_amount: (amount * (1 + (element.gst_percent || 0) / 100)),
                            doctor_amt: element.doctor_share_amount,
                            doctor_percent: element.doctor_share_percent, old_doctor_amt: element.doctor_share_amount,
                            new_doctor_amt: element.doctor_share_amount, hospital_amt: element.hospital_share_amount,
                            hospital_percent: element.hospital_share_percent, old_hospital_amt: element.hospital_share_amount,
                            new_hospital_amt: element.hospital_share_amount, interval_time: element.interval_time,
                            interval_amount: element.interval_amount, service_name: element.service_name,
                            service_head_name: element.service_head, sevice_code: element.service_code,
                            service_head_code: element.service_head_code, edit_unit: element.edit_unit,
                            edit_amount: element.edit_amount, edit_discount: element.edit_discount,
                            doctor_name: (element.doctor_name || PatientDetails?.doctor_name), doctor_id: (element.doctor_id || PatientDetails?.doctor_id),
                            gst_percent: element.gst_percent || 0, hours: element.unit_type === 'Hrs' ? element.unit?.split(":")[0] : '',
                            minutes: element.unit_type === 'Hrs' ? element.unit?.split(":")[1] : '',
                            service_details_id: element?.service_details_id,
                            service_head_id: element?.service_head_id, tempUnit: element?.unit, tempRate: element?.service_charge,
                            review_days: element?.review_days, review_count: element?.review_count,
                            charge_id: element?.charge_id, module_type: element?.module_type,
                            doctor_percent_w_r: element?.doctor_share_percent, hospital_percent_w_r: element?.hospital_share_percent,
                            doctor_list: formState?.orderList[index]?.doctor_list, ward_list: formState?.orderList[index]?.ward_list
                        };
                        return { ...prev, orderList: updatedOrderList };
                    });
                }
            }).catch((error) => {
                setIsLoader(false);
                if (error?.response?.data?.message) {
                    errorMessage(error?.response?.data?.message)
                } else {
                    errorMessage(error.message)
                }
            })
        } catch (error) {
            setIsLoader(false);
            errorMessage(error.message)
        }
    }

    const onAddHandler = (overrideServiceData) => {
        try {
            let { selected_bill_doc, selectedward } = formState || {};
            let service_data = overrideServiceData || formState?.service_data;
            let { unit_type, total_amount = 0, gst_percent = 0, unit = 0, rate_per_unit = 0 } = service_data || {};

            if (
                !overrideServiceData &&
                isMandatoryConcessionRemarksEnabled() &&
                (+service_data?.concession_amt || 0) > 0 &&
                !((service_data?.individual_concession_comments || '').trim())
            ) {
                setConcessionRemarksOpen(true);
                return;
            }

            let discountTotal = (+service_data?.total_amt || 0) - (+service_data?.concession_amt || 0)
            let incGst = loggedInUserInfo?.is_gst_enabled ? CommonValidation.calculateTotalWithGST(discountTotal, service_data.gst_percent) : 0
            let tltGstdiff = loggedInUserInfo?.is_gst_enabled ? incGst - discountTotal : 0
            let sgstCgst = loggedInUserInfo?.is_gst_enabled ? +tltGstdiff / 2 : 0
            let service_list = {
                ...service_data,
                total_with_discount: discountTotal,
                service_with_gst_total_amt: +CommonValidation.formatAmount(incGst),
                gst_amount: +CommonValidation.formatAmount(tltGstdiff),
                sgst_amount: +CommonValidation.formatAmount(sgstCgst),
                cgst_amount: +CommonValidation.formatAmount(sgstCgst),
                igst_amount: +CommonValidation.formatAmount(tltGstdiff),
                taxable_amount: discountTotal,
                sub_total_amount: service_data.total_amt,
                concession_applicable: service_data?.edit_discount ? (service_data?.is_hospital ? service_data?.new_hospital_amt : discountTotal) : 0,
                module_type: service_data.module_type,
                unit: service_data?.unit,
                service_head_id: service_data?.service_head_id,
                doctor_id: formState.selected_bill_doc?.doctor_id || formState.selected_bill_doc_id,
                doctor_name: formState.selected_bill_doc?.doctor_name || formState.selected_bill_doc,
                id: service_data?.id ? service_data?.id : null,
                package_detail_id: service_data?.package_detail_id ? service_data?.package_detail_id : null,
                package_name: service_data?.package_name ? service_data?.package_name : '',
                individual_concession_comments: (+service_data?.concession_amt || 0) > 0 ? (service_data?.individual_concession_comments || '') : '',
            };

            let isDuplicate = false;

            setformState((prev) => {
                const orderList = [...prev.orderList];

                if (!prev.isEdit && orderList.find((item, index) => (index !== formState.selectedIndex && item?.service_details_id === service_list?.service_details_id && item?.doctor_id === service_list?.doctor_id))) {
                    isDuplicate = true;
                    errorMessage("Service already exists in the order.");
                    return prev;
                }
                if (prev.isEdit) {
                    orderList[prev.selectedIndex] = service_list;
                } else {
                    orderList.push(service_list);
                }
                return { ...prev, orderList, dupOrderList: JSON.stringify(orderList) };
            });
            if (!isDuplicate) {
                setTimeout(() => onClearServiceData(), 50);
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onSelectServiceHandler = (value) => {
        try {
            setformState((prev) => {
                let serviceData = {}
                if (value !== null) {
                    if ('emergency' in value) {
                        serviceData = value?.emergency
                    } else if ('holiday' in value) {
                        serviceData = value?.holiday
                    } else {
                        serviceData = value
                    }
                }

                const sharedFields = {
                    rate_per_unit: serviceData.service_charge,
                    unit: serviceData.unit,
                    unit_type: serviceData.unit_type,
                    total_amt: serviceData.service_charge,
                    total_with_discount: serviceData.service_charge,
                    doctor_amt: serviceData.doctor_share_amount,
                    doctor_percent: serviceData.doctor_share_percent,
                    old_doctor_amt: serviceData.doctor_share_amount,
                    new_doctor_amt: serviceData.doctor_share_amount,
                    hospital_amt: serviceData.hospital_share_amount,
                    hospital_percent: serviceData.hospital_share_percent,
                    old_hospital_amt: serviceData.hospital_share_amount,
                    new_hospital_amt: serviceData.hospital_share_amount,
                    interval_time: serviceData.interval_time,
                    interval_amount: serviceData.interval_amount,
                    service_name: serviceData.service_name,
                    service_head_name: serviceData.service_head,
                    service_code: serviceData.service_code,
                    service_head_code: serviceData.service_head_code,
                    edit_unit: serviceData.edit_unit,
                    edit_amount: serviceData.edit_amount,
                    edit_discount: serviceData.edit_discount,
                    doctor_name: serviceData.doctor_name,
                    doctor_id: serviceData.doctor_id,
                    start_time: serviceData.start_time,
                    end_time: serviceData.end_time,
                    gst_percent: serviceData.gst_percent || 0,
                    hours: serviceData.unit_type === 'Hrs' ? serviceData.unit?.split(":")[0] : '',
                    minutes: serviceData.unit_type === 'Hrs' ? serviceData.unit?.split(":")[1] : '',
                    service_details_id: serviceData?.service_details_id,
                    doctor_id: serviceData?.doctor_id,
                    review_days: serviceData?.review_days,
                    review_count: serviceData?.review_count,
                    charge_id: serviceData?.charge_id,
                    doctor_name: serviceData?.doctor_name,
                    module_type: serviceData?.module_type,
                    doctor_percent_w_r: +(serviceData?.doctor_share_percent?.toFixed(2)),
                    hospital_percent_w_r: +(serviceData?.hospital_share_percent?.toFixed(2)),
                    start_date: new Date(),
                    end_date: null,
                    is_hospital: serviceData?.is_hospital,
                    service_head_id: serviceData?.service_head_id,
                    op_order_number: serviceData?.op_order_number,
                    old_time_taken: serviceData.unit_type === 'Hrs' ? serviceData?.unit : null,
                    doc_discount_amt: '',
                    doc_discount_percent: '',
                    doc_discount_percent_w_r: '',
                    hos_discount_amt: '',
                    hos_discount_percent: '',
                    hos_discount_percent_w_r: '',
                    is_sharable: serviceData?.is_sharable,
                    is_consultation: serviceData?.is_consultation
                };

                if (serviceData?.membership_discount_percentage) {
                    sharedFields.membership_discount_percentage = true
                    if (serviceData?.is_sharable) {
                        const baseTotalAmt = serviceData.service_charge;
                        const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(sharedFields.doctor_percent, baseTotalAmt)
                        const updatedOldHos = CommonValidation.getDiscountAmountWithRound(sharedFields.hospital_percent, baseTotalAmt)
                        const disDoc = CommonValidation.getDiscountAmountWithRound(0, updatedOldDoc)
                        const disHos = CommonValidation.getDiscountAmountWithRound(serviceData?.membership_discount_percentage, updatedOldHos)
                        const conTlt = (+disDoc) + (+disHos)

                        sharedFields.total_amt = baseTotalAmt
                        sharedFields.total_with_discount = baseTotalAmt - disHos
                        sharedFields.old_doctor_amt = updatedOldDoc
                        sharedFields.old_hospital_amt = updatedOldHos
                        sharedFields.new_doctor_amt = updatedOldDoc - disDoc
                        sharedFields.new_hospital_amt = updatedOldHos - disHos
                        sharedFields.doctor_amt = updatedOldDoc - disDoc
                        sharedFields.hospital_amt = updatedOldHos - disHos
                        sharedFields.doc_discount_amt = disDoc
                        sharedFields.hos_discount_amt = disHos
                        sharedFields.hos_discount_percent = serviceData?.membership_discount_percentage
                        sharedFields.hos_discount_percent_w_r = serviceData?.membership_discount_percentage
                        sharedFields.concession_amt = CommonValidation.formatAmount(conTlt)
                        sharedFields.concession_percent = serviceData?.membership_discount_percentage
                        sharedFields.concession_percent_w_r = serviceData?.membership_discount_percentage
                        sharedFields.concession_comments = "Membership concession"
                    } else {
                        sharedFields.concession_percent = serviceData?.membership_discount_percentage
                        sharedFields.concession_percent_w_r = serviceData?.membership_discount_percentage
                        sharedFields.total_with_discount = (sharedFields.total_amt - CommonValidation.getDiscountAmountWithRound(serviceData?.membership_discount_percentage, sharedFields.total_amt))
                        sharedFields.concession_amt = +CommonValidation.getDiscountAmountWithRound(serviceData?.membership_discount_percentage, sharedFields.total_amt)
                    }
                }

                return {
                    ...prev,
                    selected_service: value !== null ? serviceData : null,
                    service_data: {
                        ...prev.service_data,
                        ...sharedFields,
                    },
                };
            });

        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onClearServiceData = (is_from) => {
        try {
            setformState((prev) => ({
                ...prev,
                selected_service: null,
                service_data: {
                    rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
                    doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
                    hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
                    interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
                    service_code: '', service_head_code: '', edit_unit: false, edit_amount: false,
                    edit_discount: false, doctor_name: '', doctor_id: '', start_time: '',
                    end_time: '', doc_discount_amt: '', doc_discount_percent: '',
                    hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
                    concession_percent: '', gst_percent: 0, hours: '', minutes: '',
                    concession_comments: '', service_details_id: '', doctor_id: '',
                    review_days: '', review_count: '', charge_id: '',
                    gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
                    taxable_amount: '', sub_total_amount: '', round_off: '',
                    received_amount: '', net_amount: '', concession_percent_w_r: '',
                    doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
                    doctor_percent_w_r: '', hospital_percent_w_r: '',
                    module_type: '', start_date: new Date(), end_date: null, is_hospital: false,
                    service_head_id: null, doctor_id: '', op_order_number: '',
                    id: null
                },
                isEdit: false,
                selectedIndex: null,
                orderList: is_from === 'clear' ? [] : prev.orderList
            }))
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const handleClear = () => {
        setformState((prev) => ({
            ...prev,
            orderList: [],
            selected_bill_doc: null,
            selected_service: null,
            selected_temp_pack: null,
            service_data: {
                rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amount: '',
                doctor_amt: '', doctor_percent: '', hospital_amt: '', hospital_percent: '',
                interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
                sevice_code: '', service_head_code: '', edit_unit: '', edit_amount: '',
                edit_discount: '', doctor_name: '', doctor_id: '', old_doctor_amt: '', old_hospital_amt: ''
            },
            isEdit: false,
            selectedIndex: null,
        }))
    }

    const getTemplateData = (value) => {
        const patientTypeMap = {
            old_patient: "Old Patient",
            new_patient: "New Patient",
            review_patient: 'Review Patient'
        };
        try {
            setIsLoader(true);
            let patientType = patientTypeMap[PatientDetails?.patient_type] || PatientDetails?.patient__patient_type;
            let template_id = value?.template_id ? value?.template_id : ''
            let package_id = value?.package_id ? value?.package_id : ''
            let doctor_id = PatientDetails?.doctor_id || '';

            const isDuplicate = formState.orderList?.some(item => {
                if (template_id) {
                    return item?.template_id === template_id;
                } else if (package_id) {
                    return item?.package_id === package_id;
                }
                return false;
            });

            if (isDuplicate) {
                setIsLoader(false);
                if (template_id) {
                    errorMessage("Service Template Already Exist.");
                } else {
                    errorMessage('Service Package Already Exist.');
                }
                return;
            }

            RestAPIService.getAll(Serviceurls.NEW_BILLING_OP_TEMPLATE_GET
                + '?template_id=' + template_id +
                '&package_id=' + package_id +
                '&doctor_id=' + doctor_id +
                '&patient_type=' + patientType +
                '&patient_id=' + PatientDetails?.patient_id
            ).then((response) => {
                if (response?.data?.status === 'success') {
                    setIsLoader(false);
                    let templateList = [];
                    let data = response?.data?.data?.package_line ? response?.data?.data?.package_line : response?.data?.data?.template_line
                    let templateData = response?.data?.data;
                    data?.forEach((element, index) => {
                        let amount = element?.service_charge;
                        let serviceObj = {
                            rate_per_unit: amount, unit: element.unit,
                            unit_type: element.unit_type,
                            total_amount: (amount * (1 + (element.gst_percent || 0) / 100)),
                            total_amt: (amount * (1 + (element.gst_percent || 0) / 100)),
                            total_with_discount: (amount * (1 + (element.gst_percent || 0) / 100)),
                            sub_total_amount: (amount * (1 + (element.gst_percent || 0) / 100)),
                            doctor_amt: element.doctor_share_amount,
                            doctor_percent: element.doctor_share_percent, old_doctor_amt: element.doctor_share_amount,
                            new_doctor_amt: element.doctor_share_amount, hospital_amt: element.hospital_share_amount,
                            hospital_percent: element.hospital_share_percent, old_hospital_amt: element.hospital_share_amount,
                            new_hospital_amt: element.hospital_share_amount, interval_time: element.interval_time,
                            interval_amount: element.interval_amount, service_name: element.service_name,
                            service_head_name: element.service_head, sevice_code: element.service_code,
                            service_head_code: element.service_head_code, edit_unit: element.edit_unit,
                            edit_amount: element.edit_amount, edit_discount: element.edit_discount,
                            doctor_name: (element.doctor_name || PatientDetails?.doctor_name), doctor_id: (element.doctor_id || PatientDetails?.doctor_id),
                            gst_percent: element.gst_percent || 0, hours: element.unit_type === 'Hrs' ? element.unit?.split(":")[0] : '',
                            minutes: element.unit_type === 'Hrs' ? element.unit?.split(":")[1] : '',
                            service_details_id: element?.service_details_id,
                            service_head_id: element?.service_head_id,
                            review_days: element?.review_days, review_count: element?.review_count,
                            charge_id: element?.charge_id, module_type: element?.module_type,
                            doctor_percent_w_r: element?.doctor_share_percent, hospital_percent_w_r: element?.hospital_share_percent,
                            doctor_list: element?.doctor_list,
                            billing_display: templateData?.billing_display || null,
                            ...(element?.ward_list ? { ward_list: element?.ward_list } : null),
                            ...(templateData?.template_id ? { template_id: templateData.template_id, template_name: templateData.template_name } :
                                { package_id: templateData.package_id, package_name: templateData.package_name, package_detail_id: element?.package_detail_id })
                        }
                        let MemberDiscount = element?.is_membership_discount_applied ? element?.discount_percentage : element?.membership_discount_percentage
                        if (MemberDiscount) {
                            serviceObj.membership_discount_percentage = true
                            if (element?.is_sharable) {
                                const baseTotalAmt = (amount * (1 + (element.gst_percent || 0) / 100));
                                const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(serviceObj.doctor_percent, baseTotalAmt)
                                const updatedOldHos = CommonValidation.getDiscountAmountWithRound(serviceObj.hospital_percent, baseTotalAmt)
                                const disDoc = CommonValidation.getDiscountAmountWithRound(0, updatedOldDoc)
                                const disHos = CommonValidation.getDiscountAmountWithRound(MemberDiscount, updatedOldHos)
                                const conTlt = (+disDoc) + (+disHos)

                                serviceObj.total_amt = baseTotalAmt
                                serviceObj.total_with_discount = baseTotalAmt - disHos
                                serviceObj.old_doctor_amt = updatedOldDoc
                                serviceObj.old_hospital_amt = updatedOldHos
                                serviceObj.new_doctor_amt = updatedOldDoc - disDoc
                                serviceObj.new_hospital_amt = updatedOldHos - disHos
                                serviceObj.doctor_amt = updatedOldDoc - disDoc
                                serviceObj.hospital_amt = updatedOldHos - disHos
                                serviceObj.doc_discount_amt = disDoc
                                serviceObj.hos_discount_amt = disHos
                                serviceObj.hos_discount_percent = MemberDiscount
                                serviceObj.hos_discount_percent_w_r = MemberDiscount
                                serviceObj.concession_amt = CommonValidation.formatAmount(conTlt)
                                serviceObj.concession_percent = MemberDiscount
                                serviceObj.concession_percent_w_r = MemberDiscount
                                serviceObj.concession_comments = "Membership concession"
                            } else {
                                serviceObj.concession_percent = MemberDiscount
                                serviceObj.concession_percent_w_r = MemberDiscount
                                serviceObj.total_with_discount = (serviceObj.total_amt - CommonValidation.getDiscountAmountWithRound(MemberDiscount, serviceObj.total_amt))
                                serviceObj.concession_amt = +CommonValidation.getDiscountAmountWithRound(MemberDiscount, serviceObj.total_amt)
                            }
                        }
                        templateList?.push(serviceObj)
                    })
                    const duplicateServices = formState.orderList?.filter(orderItem =>
                        templateList.some(newItem => orderItem.service_details_id === newItem.service_details_id && orderItem.doctor_id === newItem.doctor_id)
                    );


                    if (duplicateServices.length > 0) {
                        setIsLoader(false);
                        settempDup(templateList);
                        setIsWarning(true);

                        // Store duplicate IDs in state
                        setDuplicateIds(duplicateServices.map(item => ({
                            service_details_id: item.service_details_id,
                            doctor_id: item.doctor_id
                        })));

                        return;
                    }


                    setformState((prev) => ({
                        ...prev,
                        orderList: [...prev.orderList, ...templateList],
                    }));
                }
            }).catch((error) => {
                setIsLoader(false);
                if (error?.response?.data?.message) {
                    errorMessage(error?.response?.data?.message)
                } else {
                    errorMessage(error.message)
                }
            })
        } catch (error) {
            setIsLoader(false);
            errorMessage(error.message)
        }
    }

    const isDuplicateRow = (row) => {
        return duplicateIds.some(
            dup => dup.service_details_id === row.service_details_id && dup.doctor_id === row.doctor_id
        );
    };

    const onOpenPopupHandler = (type) => {
        setOpenPopup(type)
        setPopupValues((prev) => {
            let popupUpdates = {};
            switch (type) {
                case 'rate':
                    popupUpdates.doctor_amt = formState?.service_data?.old_doctor_amt
                    popupUpdates.doctor_percent = formState?.service_data?.doctor_percent
                    popupUpdates.doctor_percent_w_r = formState?.service_data?.doctor_percent_w_r
                    popupUpdates.hospital_amt = formState?.service_data?.old_hospital_amt
                    popupUpdates.hospital_percent = formState?.service_data?.hospital_percent
                    popupUpdates.hospital_percent_w_r = formState?.service_data?.hospital_percent_w_r
                    popupUpdates.total_amt = formState?.service_data?.total_amt
                    popupUpdates.rate_per_unit = formState.service_data.unit_type === 'Nos' ? formState?.service_data?.total_amt / formState?.service_data?.unit :
                        formState.service_data.rate_per_unit
                    popupUpdates.unit = formState?.service_data?.unit
                    break
                case 'concession':
                    popupUpdates.old_doctor_amt = formState?.service_data?.old_doctor_amt
                    popupUpdates.old_hospital_amt = formState?.service_data?.old_hospital_amt
                    popupUpdates.new_doctor_amt = formState?.service_data?.new_doctor_amt
                    popupUpdates.new_hospital_amt = formState?.service_data?.new_hospital_amt
                    popupUpdates.doctor_amt = formState?.service_data?.doctor_amt
                    popupUpdates.hospital_amt = formState?.service_data?.hospital_amt
                    popupUpdates.total_amt = formState?.service_data?.total_amt
                    popupUpdates.rate_per_unit = formState?.service_data?.rate_per_unit
                    break;
                case 'time':
                    let hours = formState?.service_data?.unit?.split(":")[0] || ''
                    let mins = formState?.service_data?.unit?.split(":")[1] || ''

                    popupUpdates.hours = hours
                    popupUpdates.minutes = mins
                    popupUpdates.start_date = formState?.service_data?.start_date
                    popupUpdates.end_date = formState?.service_data?.end_date;
                    popupUpdates.interval_amount = formState?.service_data?.interval_amount
                    popupUpdates.interval_time = formState?.service_data?.interval_time
                    popupUpdates.old_time_taken = formState?.service_data?.fixed_time
                    popupUpdates.rate_per_unit = formState?.service_data?.rate_per_unit
                    popupUpdates.total_amount = formState?.service_data?.total_amount
                    popupUpdates.sub_total_amount = formState?.service_data?.sub_total_amount
                    popupUpdates.unit = formState?.service_data?.unit
                    popupUpdates.gst_percent = formState?.service_data?.gst_percent
                    break;
            }
            return {
                ...prev,
                ...popupUpdates,
                concession_amt: formState?.service_data?.concession_amt,
                concession_percent: formState?.service_data?.concession_percent,
                concession_percent_w_r: formState?.service_data?.concession_percent_w_r,
                concession_comments: formState?.service_data?.concession_comments,
                individual_concession_comments: formState?.service_data?.individual_concession_comments || '',
                line_item_remarks: formState?.service_data?.line_item_remarks || formState?.service_data?.remarks || '',
                doc_discount_amt: formState?.service_data?.doc_discount_amt,
                doc_discount_percent: formState?.service_data?.doc_discount_percent,
                doc_discount_percent_w_r: formState?.service_data?.doc_discount_percent_w_r,
                hos_discount_amt: formState?.service_data?.hos_discount_amt,
                hos_discount_percent: formState?.service_data?.hos_discount_percent,
                hos_discount_percent_w_r: formState?.service_data?.hos_discount_percent_w_r,
                doctor_percent: formState?.service_data?.doctor_percent,
                doctor_percent_w_r: formState?.service_data?.doctor_percent_w_r,
                hospital_percent: formState?.service_data?.hospital_percent,
                hospital_percent_w_r: formState?.service_data?.hospital_percent_w_r,
                unit_type: formState?.service_data?.unit_type,
                is_hospital: formState?.service_data?.is_hospital,
                service_head_id: formState?.service_data?.service_head_id,
                op_order_number: formState?.service_data?.op_order_number,
                old_time_taken: formState?.service_data?.old_time_taken
            }
        })
    }

    const withOutShareHandler = useCallback((e, key) => {
        try {
            const value = e.target.value
            setformState((prev) => {
                const update = { ...prev.service_data };
                switch (key) {
                    case 'rate_per_unit':
                        let Hours = (update?.hours === "" ? "00" : (update?.hours)?.toString()?.length < 2 ? ("0" + update?.hours) : update?.hours) + ":" + (update?.minutes === "" ? "00" : (update?.minutes)?.toString()?.length < 2 ? ("0" + update?.minutes) : update?.minutes) + ":" + "00"
                        let hourTotal = update.unit_type === 'Hrs' ? CalculateHourAmount(value, Hours, update.old_time_taken, update?.interval_time, update?.interval_amount) : 0
                        const newRatePerUnit = update.unit_type === 'Hrs' ? value : (value * update.unit)

                        update.rate_per_unit = value;
                        update.total_amt = update.unit_type === 'Hrs' ? hourTotal : (value * update.unit);
                        update.concession_amt = newRatePerUnit ? +CommonValidation.getDiscountAmountWithRound(update.concession_percent, newRatePerUnit) : ''
                        update.concession_percent = value ? update.concession_percent : ''
                        update.concession_percent_w_r = value ? update.concession_percent_w_r : ''
                        if (!update.concession_amt || +update.concession_amt <= 0) {
                            update.individual_concession_comments = ''
                        }
                        break;
                    case 'concession_discount_amt':
                        if (CommonValidation.DecimalNumber(value) && value > 0 && value <= update.total_amt || value === '') {
                            update.concession_amt = value
                            update.concession_percent = value ? +CommonValidation.getDiscountPercentage(value, update.total_amt) : ''
                            update.concession_percent_w_r = value ? +CommonValidation.getDiscountPercentageWithRound(value, update.total_amt) : ''
                            if (!value || +value <= 0) {
                                update.individual_concession_comments = ''
                            }
                        }
                        break;
                    case 'concession_discount_percent':
                        if (CommonValidation.DecimalNumber(value) && value > 0 && value <= 100 || value === '') {
                            update.concession_percent = value
                            update.concession_percent_w_r = value
                            update.concession_amt = +CommonValidation.getDiscountAmountWithRound(value, update.total_amt)
                            if (!value || +value <= 0) {
                                update.individual_concession_comments = ''
                            }
                        }
                        break;
                    default: break;
                }
                return { ...prev, service_data: update }
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }, [formState?.service_data])

    const convertTimeToDecimal = (time) => {
        try {
            let [hours, minutes] = time?.split(':')?.map(Number);
            return hours * 60 + minutes;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const CalculateHourAmount = (ratePerHour, changedTime, fixedTime, minTime, minAmount) => {
        let fixedTimes = convertTimeToDecimal(fixedTime);
        let changedTimes = convertTimeToDecimal(changedTime);
        let minTimes = convertTimeToDecimal(minTime ? minTime : '00:00');

        let changeAndFixedTime = changedTimes - fixedTimes;
        let time = changeAndFixedTime > 0 ? changeAndFixedTime : 0;

        let timeCalculateTime = (minTimes === 0) ? 0 : Math.ceil(time / minTimes);

        let totalCost = (+ratePerHour) + (timeCalculateTime * (minAmount ? minAmount : 0));

        return totalCost;
    };

    const popupTextBox = (key, values, multiline, row, labels, readOnly, width) => {
        try {
            return (
                <TextField
                    autoComplete='off'
                    size='small'
                    sx={{ width: width || '13dvw' }}
                    value={values}
                    onChange={(e) => onPopupChangeHandler(e, key)}
                    multiline={multiline}
                    rows={row}
                    label={labels}
                    InputProps={{ readOnly: readOnly, emed_tid: key }}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onPopupChangeHandler = (e, key) => {
        try {
            let value = e.target.value;

            setPopupValues((prev) => {
                let updateState = {};

                const pageType = formState?.patientData?.appointment_id ? 'op' : 'ip';
                const admissionTime = new Date(formState?.patientData?.admission_date);
                const currentTime = new Date();

                const diffMs = (currentTime - admissionTime) + 3600000;
                const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
                const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                const minHoursForIP = diffHours < 24 ? 24 : diffHours;
                const minMinutesForIP = diffHours < 24 ? 59 : diffMinutes;

                const maxHours = pageType === 'op' ? 24 : minHoursForIP;
                const maxMinutes = pageType === 'op' ? 59 : minMinutesForIP;

                switch (key) {
                    case 'doctor_amt':
                        if (CommonValidation.DecimalNumber(value) || value === '') {
                            let totalAmt = (+value) + (+popupValues.hospital_amt)
                            updateState.doctor_amt = value;
                            updateState.new_doctor_amt = value;
                            updateState.old_doctor_amt = value;
                            updateState.total_amt = totalAmt
                            updateState.rate_per_unit = popupValues?.unit_type === 'Hrs' ? ((+value) + (+popupValues.hospital_amt)) : totalAmt / popupValues.unit
                            updateState.doctor_percent = +CommonValidation.getDiscountPercentage(value, totalAmt)
                            updateState.doctor_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, totalAmt)
                            updateState.hospital_percent = +CommonValidation.getDiscountPercentage(+popupValues.hospital_amt, totalAmt)
                            updateState.hospital_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(+popupValues.hospital_amt, totalAmt)
                            updateState.doc_discount_amt = +CommonValidation.getDiscountAmountWithRound(+popupValues.doc_discount_percent, value)
                        }
                        break;
                    case 'hospital_amt':
                        if (CommonValidation.DecimalNumber(value) || value === '') {
                            let totalAmt = (+value) + (+popupValues.doctor_amt)
                            updateState.hospital_amt = value;
                            updateState.new_hospital_amt = value;
                            updateState.old_hospital_amt = value;
                            updateState.total_amt = totalAmt
                            updateState.rate_per_unit = popupValues?.unit_type === 'Hrs' ? ((+value) + (+popupValues.doctor_amt)) : totalAmt / popupValues.unit
                            updateState.doctor_percent = +CommonValidation.getDiscountPercentage(+popupValues.doctor_amt, totalAmt) || 0
                            updateState.doctor_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(+popupValues.doctor_amt, totalAmt) || 0
                            updateState.hospital_percent = +CommonValidation.getDiscountPercentage(value, totalAmt) || 0
                            updateState.hospital_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, totalAmt) || 0
                            updateState.hos_discount_amt = +CommonValidation.getDiscountAmountWithRound(+popupValues.hos_discount_percent, value) || 0
                        }
                        break;
                    case 'doctor_discount_amt':
                        if (CommonValidation.DecimalNumber(value) && +value <= popupValues.old_doctor_amt || value === '') {
                            updateState.doc_discount_amt = value
                            updateState.new_doctor_amt = +CommonValidation.formatAmount(+popupValues.old_doctor_amt - value) || 0
                            updateState.doc_discount_percent = +CommonValidation.getDiscountPercentage(value, +popupValues.old_doctor_amt) || 0
                            updateState.doc_discount_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, +popupValues.old_doctor_amt) || 0
                            updateState.doctor_amt = +CommonValidation.formatAmount(+popupValues.old_doctor_amt - value) || 0
                        }
                        break;
                    case 'hospital_discount_amt':
                        if (CommonValidation.DecimalNumber(value) && +value <= popupValues.old_hospital_amt || value === '') {
                            updateState.hos_discount_amt = value
                            updateState.new_hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - value) || 0
                            updateState.hos_discount_percent = +CommonValidation.getDiscountPercentage(value, popupValues.old_hospital_amt) || 0
                            updateState.hos_discount_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, popupValues.old_hospital_amt) || 0
                            updateState.hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - value) || 0
                        }
                        break;
                    case 'doctor_discount_percent':
                        if (CommonValidation.DecimalNumber(value) && +value <= 100 || value === '') {
                            let disAmt = CommonValidation.getDiscountAmountWithRound(value, popupValues.old_doctor_amt) || 0
                            updateState.doc_discount_percent = value
                            updateState.doc_discount_percent_w_r = value
                            updateState.doc_discount_amt = +CommonValidation.getDiscountAmountWithRound(value, popupValues.old_doctor_amt) || 0
                            updateState.new_doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt - disAmt) || 0
                            updateState.doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt - disAmt) || 0
                        }
                        break;
                    case 'hospital_discount_percent':
                        if (CommonValidation.DecimalNumber(value) && +value <= 100 || value === '') {
                            let disAmt = CommonValidation.getDiscountAmount(value, popupValues.old_hospital_amt) || 0
                            updateState.hos_discount_percent = value
                            updateState.hos_discount_percent_w_r = value
                            updateState.hos_discount_amt = +CommonValidation.getDiscountAmountWithRound(value, popupValues.old_hospital_amt) || 0
                            updateState.new_hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - disAmt) || 0
                            updateState.hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - disAmt) || 0
                        }
                        break;
                    case 'concession_comments':
                        if (value?.length <= 500 || value === '') {
                            updateState.concession_comments = value
                        }
                        break;
                    case 'individual_concession_comments':
                        if (value?.length <= 500 || value === '') {
                            updateState.individual_concession_comments = value
                        }
                        break;
                    case 'line_item_remarks':
                        updateState.line_item_remarks = clampLineItemRemarks(value)
                        break;
                    case 'hours':
                        if (value === "" || (CommonValidation.numberOnly(value) && value >= 0 && value <= 24) && pageType === 'op') {
                            updateState.hours = value;
                            if (value === '24') {
                                updateState.minutes = "00";
                            }
                        } else if (value === "" || (CommonValidation.numberOnly(value) && value >= 0 && value <= maxHours) && pageType === 'ip') {
                            updateState.hours = value;
                            if (value === maxHours.toString()) {
                                updateState.minutes = "00";
                            }
                        }
                        break;
                    case 'minutes':
                        const hourVal = parseInt(popupValues?.hours || 0);
                        if (value === "" ||
                            (CommonValidation.numberOnly(value) && value >= 0 && value <= 59 && hourVal < 24 && pageType === 'op')
                        ) {
                            updateState.minutes = value;
                        } else if (value === "" ||
                            (CommonValidation.numberOnly(value) && value >= 0 && value <= maxMinutes && hourVal < maxHours && pageType === 'ip')
                        ) {
                            updateState.minutes = value;
                        }
                        break;
                }
                return { ...prev, ...updateState };
            });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const onSavePopupHandler = (type) => {
        try {
            setformState((prev) => {
                let updates = { ...prev.service_data };

                switch (type) {
                    case 'rate':
                        let total = 0;
                        if (popupValues.unit_type === 'Nos') {
                            total = popupValues.rate_per_unit * popupValues.unit
                        } else {
                            let Hours = (popupValues?.hours === "" ? "00" : (popupValues?.hours)?.toString()?.length < 2 ? ("0" + popupValues?.hours) : popupValues?.hours) + ":" + (popupValues?.minutes === "" ? "00" : (popupValues?.minutes)?.toString()?.length < 2 ? ("0" + popupValues?.minutes) : popupValues?.minutes) + ":" + "00"
                            let hourTotal = CalculateHourAmount(popupValues.rate_per_unit, Hours, popupValues.old_time_taken, popupValues?.interval_time, popupValues?.interval_amount)
                            total = hourTotal
                        }
                        let concession = (+popupValues.doc_discount_amt) + (+popupValues.hos_discount_amt)

                        updates.doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.doctor_percent = +popupValues.doctor_percent
                        updates.hospital_percent = +popupValues.hospital_percent
                        updates.old_doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.old_hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.new_doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.new_hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.total_amt = +CommonValidation.formatAmount(total)
                        updates.rate_per_unit = +CommonValidation.formatAmount(popupValues.rate_per_unit)
                        updates.doc_discount_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.doc_discount_percent, popupValues.old_doctor_amt)
                        updates.hos_discount_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.hos_discount_percent, popupValues.old_hospital_amt)
                        updates.concession_amt = +CommonValidation.formatAmount(concession)
                        updates.concession_percent = +CommonValidation.getDiscountPercentage(concession, total)
                        updates.concession_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(concession, total)
                        updates.hos_discount_percent_w_r = +popupValues.hos_discount_percent_w_r
                        updates.doc_discount_percent_w_r = +popupValues.doc_discount_percent_w_r
                        updates.doctor_percent_w_r = +popupValues.doctor_percent_w_r
                        updates.hospital_percent_w_r = +popupValues.hospital_percent_w_r
                        break;
                    case 'concession':
                        let concessionAmt = (+popupValues.doc_discount_amt) + (+popupValues.hos_discount_amt)

                        updates.doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.doctor_percent = +popupValues.doctor_percent
                        updates.hospital_percent = +popupValues.hospital_percent
                        updates.old_doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt)
                        updates.old_hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt)
                        updates.new_doctor_amt = +CommonValidation.formatAmount(popupValues.new_doctor_amt)
                        updates.new_hospital_amt = +CommonValidation.formatAmount(popupValues.new_hospital_amt)
                        updates.total_amt = +CommonValidation.formatAmount(popupValues.total_amt)
                        updates.concession_amt = +CommonValidation.formatAmount(concessionAmt)
                        updates.concession_percent = +CommonValidation.getDiscountPercentage(concessionAmt, popupValues.total_amt)
                        updates.doc_discount_amt = +CommonValidation.formatAmount(popupValues.doc_discount_amt)
                        updates.doc_discount_percent = +popupValues.doc_discount_percent
                        updates.hos_discount_amt = +CommonValidation.formatAmount(popupValues.hos_discount_amt)
                        updates.hos_discount_percent = +popupValues.hos_discount_percent
                        updates.concession_comments = popupValues.concession_comments
                        if (isMandatoryConcessionRemarksEnabled()) {
                            updates.individual_concession_comments = concessionAmt > 0 ? (popupValues.individual_concession_comments || '') : ''
                        }
                        if (isLineItemRemarksEnabled()) {
                            updates.line_item_remarks = clampLineItemRemarks(popupValues.line_item_remarks || '')
                        }
                        updates.hos_discount_percent_w_r = +popupValues.hos_discount_percent_w_r
                        updates.doc_discount_percent_w_r = +popupValues.doc_discount_percent_w_r
                        updates.concession_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(concessionAmt, popupValues.total_amt)
                        updates.doctor_percent_w_r = +popupValues.doctor_percent_w_r
                        updates.hospital_percent_w_r = +popupValues.hospital_percent_w_r
                        break;
                    case 'time':
                        let Hours = (popupValues?.hours === "" ? "00" : (popupValues?.hours)?.toString()?.length < 2 ? ("0" + popupValues?.hours) : popupValues?.hours) + ":" + (popupValues?.minutes === "" ? "00" : (popupValues?.minutes)?.toString()?.length < 2 ? ("0" + popupValues?.minutes) : popupValues?.minutes) + ":" + "00"
                        let hourTotal = CalculateHourAmount(popupValues.rate_per_unit, Hours, popupValues.old_time_taken, popupValues?.interval_time, popupValues?.interval_amount)

                        updates.total_amt = hourTotal
                        updates.unit = Hours.split(":")[0] + ":" + Hours.split(":")[1]
                        updates.old_time_taken = popupValues.old_time_taken
                        updates.interval_amount = popupValues.interval_amount
                        updates.interval_time = popupValues.interval_time
                        updates.rate_per_unit = popupValues.rate_per_unit
                        updates.old_doctor_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.doctor_percent, hourTotal)
                        updates.old_hospital_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.hospital_percent, hourTotal)
                        let docDisc = CommonValidation.getDiscountAmountWithRound(popupValues.doc_discount_percent, updates.old_doctor_amt)
                        let hosDis = CommonValidation.getDiscountAmountWithRound(popupValues.hos_discount_percent, updates.old_hospital_amt)
                        updates.doc_discount_amt = +docDisc
                        updates.hos_discount_amt = +hosDis
                        updates.concession_amt = updates.doctor_amt && updates.hospital_amt ? (+docDisc) + (+hosDis) : CommonValidation.getDiscountAmountWithRound(popupValues.concession_percent, hourTotal)
                        break;
                }

                return { ...prev, service_data: updates };
            });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const TimePopup = () => {
        let totalAmt = +popupValues.doctor_amt + (+popupValues.hospital_amt)
        return (
            <>{openPopup === 'rate' ?
                <Dialog open={openPopup === 'rate'} maxWidth='sm' fullWidth>
                    <Box className='com_billing_popup'>
                        <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography fontSize={'1rem'} fontWeight={600}>Update Rate Per Unit</Typography>
                            <IconButton
                                onClick={() => setOpenPopup(null)}
                            >
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                            </IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Typography fontSize={'1rem'} fontWeight={600}>Doctor Consultation</Typography>
                            <Box component={'div'} display={'flex'} justifyContent={'space-evenly'}>
                                <Typography fontSize={'1rem'} fontWeight={600}>{`Rate / Unit - ${popupValues?.rate_per_unit ? CommonValidation.formatAmount(popupValues?.rate_per_unit) : '0'}`}</Typography>
                                <Typography fontSize={'1rem'} fontWeight={600}>{`Unit - ${popupValues?.unit}`}</Typography>
                            </Box>
                            <Box component={'div'} mt={'1rem'}>
                                <Grid container sx={{ display: 'flex', alignItems: 'center' }} rowGap={2}>
                                    <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Doctor Share</Typography></Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('doctor_amt', popupValues?.doctor_amt, false, 1, `Doctor Fee (${CurrencySymbol})`)}
                                    </Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('doctor_percent', popupValues?.doctor_percent_w_r, false, 1, 'Doctor Percentage (%)', true)}
                                    </Grid>
                                    <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Hosptial Share</Typography></Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('hospital_amt', popupValues?.hospital_amt, false, 1, `Hospital Fee (${CurrencySymbol})`)}
                                    </Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('hospital_percent', popupValues?.hospital_percent_w_r, false, 1, `Hospital Percentage (%)`, true)}
                                    </Grid>
                                    <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Total Amount</Typography></Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('total_amt', totalAmt ? CommonValidation.formatAmount(totalAmt) : '', false, 1, `Total Amount (${CurrencySymbol})`, true)}
                                    </Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('total_percent', '100.00', false, 1, `Total Percentage (%)`, true)}
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                        <Box m={'1rem'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                            <Button variant='outlined' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                onClick={() => setOpenPopup(null)}
                            >Close</Button>
                            <Button variant='contained' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                onClick={() => {
                                    onSavePopupHandler('rate')
                                    setOpenPopup(null)
                                }}
                            >Save</Button>
                        </Box>
                    </Box>
                </Dialog> :
                openPopup === 'concession' ?
                    <Dialog open={openPopup === 'concession'} maxWidth='sm' fullWidth>
                        <Box className='com_billing_popup'>
                            <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                                <Typography fontSize={'1rem'} fontWeight={600}>Concession</Typography>
                                <IconButton
                                    onClick={() => setOpenPopup(null)}
                                >
                                    <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                                </IconButton>
                            </Box>
                            <Box component={'div'} p={'0.5rem'}>
                                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Typography fontSize={'1rem'} fontWeight={600}>Doctor Consultation</Typography>
                                    <Typography fontSize={'1rem'} fontWeight={600}>{`Bill Amount : ${CommonValidation.formatAmount(popupValues?.total_amt)}`}</Typography>
                                </Box>
                                <Box component={'div'} mt={'1rem'}>
                                    <Grid container sx={{ display: 'flex', alignItems: 'center' }} rowGap={2}>
                                        <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Doctor Concession</Typography></Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('doctor_discount_amt', popupValues?.doc_discount_amt, false, 1, `Amount (${CurrencySymbol})`, (popupValues?.is_hospital || formState?.service_data?.membership_discount_percentage))}
                                        </Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('doctor_discount_percent', popupValues?.doc_discount_percent_w_r, false, 1, 'Percentage (%)', (popupValues?.is_hospital || formState?.service_data?.membership_discount_percentage))}
                                        </Grid>
                                        <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Hosptial Concession</Typography></Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('hospital_discount_amt', popupValues?.hos_discount_amt, false, 1, `Amount (${CurrencySymbol})`, formState?.service_data?.membership_discount_percentage)}
                                        </Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('hospital_discount_percent', popupValues?.hos_discount_percent_w_r, false, 1, 'Percentage (%)', formState?.service_data?.membership_discount_percentage)}
                                        </Grid>
                                    </Grid>
                                </Box>
                                {popupValues?.is_hospital ? <Box><FormHelperText sx={{ color: 'red', fontSize: COMMON_STYLES.FONT_SIZE_SM, textAlign: 'center' }}>Concession Enable Only For Hospital !</FormHelperText></Box> : null}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '0.5rem' }}>
                                    <Box>
                                        <Typography fontSize={'0.8dvw'} color={Colors.grayShade}>Doctor Share</Typography>
                                        <Typography fontSize={'1rem'} fontWeight={600}>{`${CommonValidation.formatAmount(popupValues?.old_doctor_amt) || 0} - ${CommonValidation.formatAmount(popupValues?.doc_discount_amt) || 0} = ${CommonValidation.formatAmount(popupValues?.new_doctor_amt) || 0}`}</Typography>
                                    </Box>
                                    <Box mr={'2rem'}>
                                        <Typography fontSize={'0.8dvw'} color={Colors.grayShade}>Hosptial Share</Typography>
                                        <Typography fontSize={'1rem'} fontWeight={600}>{`${CommonValidation.formatAmount(popupValues?.old_hospital_amt) || 0} - ${CommonValidation.formatAmount(popupValues?.hos_discount_amt) || 0} = ${CommonValidation.formatAmount(popupValues?.new_hospital_amt) || 0}`}</Typography>
                                    </Box>
                                </Box>
                                <Box component={'div'} mt={'0.5rem'} display={'flex'} flexDirection={'column'} gap={'0.5rem'}>
                                    {isLineItemRemarksEnabled() ?
                                        popupTextBox('line_item_remarks', popupValues?.line_item_remarks, true, 3, 'Line Item Remarks', (formState?.service_data?.membership_discount_percentage), '37dvw')
                                        : null}
                                    {isMandatoryConcessionRemarksEnabled() ? (() => {
                                        const concessionApplied = ((+popupValues?.doc_discount_amt || 0) + (+popupValues?.hos_discount_amt || 0)) > 0;
                                        return popupTextBox('individual_concession_comments', concessionApplied ? popupValues?.individual_concession_comments : '', true, 3, 'Concession Remarks *', (formState?.service_data?.membership_discount_percentage || !concessionApplied), '37dvw');
                                    })() : null}
                                    {(!isMandatoryConcessionRemarksEnabled() && !isLineItemRemarksEnabled()) ?
                                        popupTextBox('concession_comments', popupValues?.concession_comments, true, 3, 'Concession Comments', (formState?.service_data?.membership_discount_percentage), '37dvw')
                                        : null}
                                </Box>
                            </Box>
                            <Box m={'0.5rem'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                                <Button variant='outlined' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                    onClick={() => setOpenPopup(null)}
                                >Close</Button>
                                <Button variant='contained' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                    disabled={formState?.service_data?.membership_discount_percentage || (isMandatoryConcessionRemarksEnabled() && (((+popupValues?.doc_discount_amt || 0) + (+popupValues?.hos_discount_amt || 0)) > 0) && !((popupValues?.individual_concession_comments || '').trim()))}
                                    onClick={() => {
                                        onSavePopupHandler('concession')
                                        setOpenPopup(null)
                                    }}
                                >Save</Button>
                            </Box>
                        </Box>
                    </Dialog> : null

            }</>
        )
    }

    const renderTable = () => {
        try {
            return (
                <Box sx={{ height: loginInfo?.module_name === 'Radiology' ? '66vh' : "58vh", width: "100%" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: 'flex-end', alignItems: 'flex-end', padding: "0.65vw", backgroundColor: "white", m: "0.5vw" }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent:"center" }}>
                            {membershipDetails?.is_memberships ? <IconButton sx={{ height: '1.5vw', width: '1.5vw', marginRight: '0.5vw' }} onClick={() => {
                            {
                                setAnchorEl(true);
                                setDialogOpen(true);
                            }
                        }}>
                            <Tooltip title="Membership Details" placement="top">
                            <img src={ImagePaths.MemberShip.default} alt='help' style={{ height: '1.3vw', width: '1.3vw', marginBottom: '0.4vw' }} />
                            </Tooltip>
                        </IconButton> : null}
                        <Autocomplete
                            size='small'
                            sx={{ width: "20dvw", mr: "0.3vw", mb: "0.3vw", mt: "-1.5vw", ml: "0.3vw" }}
                            options={formState.tempPackSugg}
                            disabled={!PatientDetails?.doctor_id}
                            getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.template_name ? `${option.template_name} - Template` : `${option?.package_name ?? ""} - Package`}
                            value={formState.selected_temp_pack}
                            onChange={(e, newValue) => { getTemplateData(newValue) }}
                            renderOption={(props, option) => (
                                <Box
                                    component="li"
                                    {...props}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        justifyContent: "flex-start",
                                        width: "100%",
                                        textAlign: "left",
                                    }}
                                >
                                    <Typography fontSize=".9vw" sx={{ width: "100%", textAlign: "left" }} >
                                        {`${option?.template_name || option?.package_name || "-"}${(option?.package_amount || option?.package_amount === 0) ? ` - ${AmountFormat(option?.package_amount || 0)}` : ""}`}
                                    </Typography>
                                    <Typography
                                        fontSize=".8vw"
                                        fontWeight="bold"
                                        sx={{ width: "100%", textAlign: "left" }}
                                        color={option?.template_name
                                            ? "#29B6F6"
                                            : option?.package_name
                                                ? "#1E972A"
                                                : "inherit"
                                        }
                                    >
                                        {option?.template_name
                                            ? "Template"
                                            : option?.package_name
                                                ? "Package"
                                                : ""}
                                    </Typography>
                                </Box>
                            )}
                            renderInput={(params) => <TextField
                                {...params}
                                label='Search Template/Package'
                                variant='standard'
                                disabled={!PatientDetails?.doctor_id}
                                InputProps={{ ...params.InputProps, emed_tid: 'ser_temp_pack' }}
                            />}
                        />
                        </Box>
                        <TableContainer sx={{ height: loginInfo?.module_name === 'Radiology' ? '51.5dvh' : '45dvh', overflow: 'auto', border: '1px solid lightgray' }}>
                            <Table stickyHeader>
                                <TableHead size="small" sx={{ "& .MuiTableCell-root": { padding: "0.25rem" } }}>
                                    <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>S.No</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Doctor Name</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7', width: '20%' }}>Service Description</TableCell>
                                        {AmountViewAccess ? <TableCell sx={{ fontSize: '0.9rem', width: "10%", fontWeight: 600, backgroundColor: '#F5F8F7' }}>Rate Per Unit</TableCell> : null}
                                        {AmountViewAccess ? <TableCell sx={{ fontSize: '0.9rem', width: "10%", fontWeight: 600, backgroundColor: '#F5F8F7', }}>Concession</TableCell> : null}
                                        {AmountViewAccess ? <TableCell sx={{ fontSize: '0.9rem', width: "10%", fontWeight: 600, backgroundColor: '#F5F8F7', }}>Total Amount</TableCell> : null}
                                        {userAccess?.editAccess && <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7', width: "10%" }}>Action</TableCell>}
                                    </TableRow>
                                </TableHead>
                                <TableBody size="small" sx={{ "& .MuiTableCell-root": { padding: "0px" } }}>
                                    {formState?.orderList?.length > 0 ? formState?.orderList?.map((row, index) => {
                                        const tempTotal = (row.tempUnit * row.tempRate) + ((row.tempUnit * row.tempRate * (row.gst_percent || 0)) / 100);
                                        let docName = formState?.fromOrderSummary ? (row?.bill_doctor_name || '-') : (row?.doctor_name || '-');
                                        return (
                                            <TableRow key={index} sx={{ backgroundColor: isDuplicateRow(row) ? '#d2f7f1' : 'white' }}>
                                                <TableCell style={{ fontSize: '0.9rem', paddingLeft: "0.5vw" }}>{index + 1}</TableCell>
                                                <TableCell sx={{ fontSize: '0.9rem', }}>
                                                    {(row?.isEditing && row?.doctor_list) ? <Autocomplete
                                                        size='small'
                                                        options={row?.doctor_list}
                                                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.doctor_name}
                                                        clearIcon={false}
                                                        value={docName}
                                                        onChange={(e, newValue) => {
                                                            getInlineServiceListData(newValue?.doctor_id, row?.ward_id, row?.service_details_id, index);
                                                        }}
                                                        sx={{
                                                            width: '10dvw',
                                                            '& .MuiInputBase-root': {
                                                                minHeight: '30px',
                                                                padding: '0 8px',
                                                                fontSize: '0.75rem',
                                                            },
                                                            '& .MuiAutocomplete-inputRoot': {
                                                                padding: '2px 0 !important',
                                                            },
                                                        }}
                                                        renderInput={(params) => <TextField
                                                            {...params}
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                sx: {
                                                                    '& input': {
                                                                        padding: '4px 0',
                                                                    },
                                                                },
                                                            }}
                                                        />}
                                                    /> : (!row?.isEditing || (row?.isEditing && !row?.doctor_list)) ? <div style={{ fontSize: '0.9rem', paddingLeft: "0.5vw" }}>{docName}</div> : null}
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '0.9rem' }}>
                                                    <Typography sx={{ fontSize: '0.9rem' }}>{row?.service_name || '-'}</Typography>
                                                </TableCell>
                                                {AmountViewAccess ? <TableCell sx={{ fontSize: '0.9rem' }}>{CommonValidation.formatAmount(row?.rate_per_unit) || '-'}</TableCell> : null}
                                                {AmountViewAccess ? <TableCell sx={{ fontSize: '0.9rem' }}> {CommonValidation.formatAmount(row?.concession_amt || 0)}</TableCell> : null}
                                                {AmountViewAccess ? <TableCell sx={{ fontSize: '0.9rem' }}>
                                                    {row?.isEditing && row?.unit_type !== 'Hrs' ? CommonValidation.formatAmount(tempTotal) : row?.total_with_discount ? CommonValidation.formatAmount(row?.total_with_discount) : '0'}
                                                </TableCell> : null}
                                                {/* <TableCell sx={{ fontSize: '0.9rem' }}>
                                                    {row?.isEditing ? (
                                                        <Box component="div" border="1px solid lightgray" borderRadius="5px" height="4dvh"
                                                            display="flex" alignItems="center" justifyContent="space-evenly" width="6dvw">
                                                            <IconButton
                                                                sx={{ height: '2.5dvh', width: '2dvw' }}
                                                                disabled={+row.tempUnit === 1}
                                                                onClick={() => {
                                                                    setformState((prev) => {
                                                                        const updatedOrderList = [...prev.orderList];
                                                                        const currentRow = { ...updatedOrderList[index] };

                                                                        currentRow.tempUnit = Math.max(1, +currentRow.tempUnit - 1);
                                                                        const baseTotalAmt = currentRow.tempUnit * currentRow.rate_per_unit;
                                                                        currentRow.total_amount = baseTotalAmt;

                                                                        if ((currentRow.doctor_amt || currentRow.hospital_amt) &&
                                                                            (currentRow.doctor_percent || currentRow.hospital_percent)) {

                                                                            if (currentRow.doctor_percent) {
                                                                                currentRow.doctor_amt = (baseTotalAmt * currentRow.doctor_percent) / 100;
                                                                            }

                                                                            if (currentRow.hospital_percent) {
                                                                                currentRow.hospital_amt = (baseTotalAmt * currentRow.hospital_percent) / 100;
                                                                            }
                                                                        }

                                                                        updatedOrderList[index] = currentRow;
                                                                        return { ...prev, orderList: updatedOrderList };
                                                                    });
                                                                }}
                                                            ><RemoveIcon color={+row.tempUnit === 1 ? 'disabled' : 'primary'} /></IconButton>
                                                            <Typography>{row.tempUnit}</Typography>
                                                            <IconButton
                                                                sx={{ height: '2.5dvh', width: '2dvw' }}
                                                                onClick={() => {
                                                                    setformState((prev) => {
                                                                        const updatedOrderList = [...prev.orderList];
                                                                        const currentRow = { ...updatedOrderList[index] };

                                                                        currentRow.tempUnit = +currentRow.tempUnit + 1;
                                                                        const baseTotalAmt = currentRow.tempUnit * currentRow.rate_per_unit;
                                                                        currentRow.total_amount = baseTotalAmt;

                                                                        if ((currentRow.doctor_amt || currentRow.hospital_amt) &&
                                                                            (currentRow.doctor_percent || currentRow.hospital_percent)) {

                                                                            if (currentRow.doctor_percent) {
                                                                                currentRow.doctor_amt = (baseTotalAmt * currentRow.doctor_percent) / 100;
                                                                            }

                                                                            if (currentRow.hospital_percent) {
                                                                                currentRow.hospital_amt = (baseTotalAmt * currentRow.hospital_percent) / 100;
                                                                            }
                                                                        }

                                                                        updatedOrderList[index] = currentRow;
                                                                        return { ...prev, orderList: updatedOrderList };
                                                                    });
                                                                }}
                                                            ><AddIcon color="primary" /></IconButton>
                                                        </Box>
                                                    ) : (row?.unit || '-')}
                                                </TableCell> */}
                                                {userAccess?.editAccess && <TableCell sx={{ fontSize: '0.9rem' }}>
                                                    {row?.isEditing ? (
                                                        <Box sx={{ display: "flex" }}>
                                                            <IconButton size='small' onClick={() => {
                                                                setformState((prev) => {
                                                                    const updatedOrderList = [...prev.orderList];
                                                                    updatedOrderList[index] = {
                                                                        ...updatedOrderList[index],
                                                                        unit: updatedOrderList[index].tempUnit,
                                                                        rate_per_unit: updatedOrderList[index].tempRate,
                                                                        total_amount: tempTotal,
                                                                        isEditing: false
                                                                    };
                                                                    return { ...prev, orderList: updatedOrderList };
                                                                });
                                                            }}>
                                                                <CheckCircleOutlineIcon color='primary' />
                                                            </IconButton>
                                                            <IconButton size='small' onClick={() => {
                                                                setformState((prev) => {
                                                                    const updatedOrderList = [...prev.orderList];
                                                                    updatedOrderList[index] = {
                                                                        ...updatedOrderList[index],
                                                                        tempUnit: updatedOrderList[index].unit,
                                                                        tempRate: updatedOrderList[index].rate_per_unit,
                                                                        isEditing: false
                                                                    };
                                                                    return { ...prev, orderList: updatedOrderList };
                                                                });
                                                            }}>
                                                                <HighlightOffIcon color='error' />
                                                            </IconButton>
                                                        </Box>
                                                    ) : (
                                                        <Box sx={{ display: "flex" }}>
                                                                <div style={{marginTop: '0.25vw'}}>
                                                                    {(() => {
                                                                        const lineOn = isLineItemRemarksEnabled();
                                                                        const concOn = isMandatoryConcessionRemarksEnabled();
                                                                        const rowHasConcession = (+row?.concession_amt || 0) > 0;
                                                                        const concessionEmpty = concOn && rowHasConcession && !((row?.individual_concession_comments || '').trim());
                                                                        const mode = lineOn && concOn ? 'both' : (lineOn ? 'line' : 'concession');
                                                                        const tooltip = mode === 'both' ? 'Line Item / Concession Remarks'
                                                                            : (mode === 'line' ? undefined : 'Concession Remarks');
                                                                        const dlgTitle = mode === 'both' ? 'Line Item & Concession Remarks'
                                                                            : (mode === 'line' ? undefined : 'Concession Remarks');
                                                                        return (
                                                                            <LineItemRemarksButton
                                                                                enabled={lineOn || concOn}
                                                                                value={mode === 'concession'
                                                                                    ? (rowHasConcession ? (row.individual_concession_comments || '') : '')
                                                                                    : (row.line_item_remarks || row.remarks || '')}
                                                                                warning={concessionEmpty}
                                                                                title={tooltip}
                                                                                dialogTitle={dlgTitle}
                                                                                fieldLabel={mode === 'concession' ? 'Concession Remarks' : 'Line Item Remarks'}
                                                                                required={mode === 'concession' && rowHasConcession}
                                                                                secondField={mode === 'both' ? {
                                                                                    label: 'Concession Remarks',
                                                                                    placeholder: 'Enter remarks for concession',
                                                                                    value: rowHasConcession ? (row.individual_concession_comments || '') : '',
                                                                                    required: rowHasConcession,
                                                                                } : undefined}
                                                                                onSave={(primary, second) => {
                                                                                    const pv = clampLineItemRemarks(primary);
                                                                                    if (mode === 'concession') {
                                                                                        setformState((prev) => {
                                                                                            const orderList = [...prev.orderList];
                                                                                            orderList[index] = { ...orderList[index], individual_concession_comments: pv };
                                                                                            return { ...prev, orderList };
                                                                                        });
                                                                                        return;
                                                                                    }
                                                                                    if (mode === 'line') {
                                                                                        setformState((prev) => {
                                                                                            const orderList = [...prev.orderList];
                                                                                            orderList[index] = { ...orderList[index], line_item_remarks: pv, remarks: pv };
                                                                                            return { ...prev, orderList };
                                                                                        });
                                                                                        return;
                                                                                    }
                                                                                    const sv = clampLineItemRemarks(second || '');
                                                                                    setformState((prev) => {
                                                                                        const orderList = [...prev.orderList];
                                                                                        orderList[index] = {
                                                                                            ...orderList[index],
                                                                                            line_item_remarks: pv,
                                                                                            remarks: pv,
                                                                                            individual_concession_comments: sv,
                                                                                        };
                                                                                        return { ...prev, orderList };
                                                                                    });
                                                                                }}
                                                                            />
                                                                        );
                                                                    })()}
                                                                </div>
                                                            <Box visibility={(row?.package_id || row?.package_detail_id) ? "hidden" : "visible"}>
                                                                <CommonEditButton onClick={() => {
                                                                    setformState((prev) => ({
                                                                        ...prev,
                                                                        service_data: row,
                                                                        selected_service: row,
                                                                        isEdit: true,
                                                                        selectedIndex: index
                                                                    }));
                                                                }} /></Box>
                                                            <CommonDeleteButton onClick={() => {
                                                                setformState((prev) => {
                                                                    const updatedOrderList = prev.orderList.filter((_, i) => i !== index);

                                                                    const remainingDuplicates = updatedOrderList.filter(orderItem =>
                                                                        duplicateIds?.some(dup =>
                                                                            dup?.service_details_id === orderItem?.service_details_id &&
                                                                            dup?.doctor_id === orderItem?.doctor_id
                                                                        )
                                                                    );

                                                                    const newDuplicateIds = duplicateIds.filter(dup =>
                                                                        remainingDuplicates?.filter(item =>
                                                                            item?.service_details_id === dup?.service_details_id &&
                                                                            item?.doctor_id === dup?.doctor_id
                                                                        )?.length > 1
                                                                    );

                                                                    setDuplicateIds(newDuplicateIds);

                                                                    return { ...prev, orderList: updatedOrderList };
                                                                });
                                                            }} />
                                                        </Box>
                                                    )}
                                                </TableCell>}
                                            </TableRow>
                                        )
                                    }) :
                                        <TableRow>
                                            <TableCell colSpan={9} align='center' sx={{ borderBottom: 'none', position: 'relative', top: '10rem' }}>
                                                No Records To Be Shown
                                            </TableCell>
                                        </TableRow>}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box component={'div'} mt={'0.5rem'} display={'flex'} justifyContent={'space-around'} alignItems={'center'}
                            ref={billingContainerRef}
                            id="data-billing-container"
                            tabIndex={0}
                            sx={{
                                width: "100%",
                                outline: 'none',
                                '&:focus-visible': { outline: 'none' },
                            }}
                        >
                            <Autocomplete
                                disabled={Object.keys(PatientDetails)?.length === 0 ? true : false}
                                size='small'
                                sx={{ width: '15dvw' }}
                                options={formState.billDocSugg}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.doctor_name}
                                value={formState.selected_bill_doc}
                                onChange={(e, newValue) => {
                                    setformState((prev) => ({
                                        ...prev, selected_bill_doc: newValue, selected_service: null,
                                        service_data: {
                                            ...prev.service_data, edit_unit: '', unit: 1
                                        },
                                    }))
                                }}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label='Bill Doctor'
                                    InputProps={{
                                        ...params.InputProps, emed_tid: 'Bl_doc',
                                    }}
                                />}
                            />

                            <Autocomplete
                                size='small'
                                sx={{ width: '40dvw' }}
                                options={formState.serviceSugg}
                                disabled={!formState.selected_bill_doc}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : `${(option?.service_head ?? option?.service_head_name) && option?.service_head_code ? `${option?.service_head ?? option?.service_head_name} (${option?.service_head_code})` : option?.service_head ?? option?.service_head_name} - ${option?.service_name && option?.service_code ? `${option?.service_name} (${option?.service_code})` : option?.service_name}`}
                                value={formState.selected_service}
                                onChange={(e, newValue) => { onSelectServiceHandler(newValue); setsearchKey('') }}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label='Search Service'
                                    disabled={!formState.selected_bill_doc}
                                    InputProps={{
                                        ...params.InputProps, emed_tid: 'ser_sear',
                                    }}
                                />}
                                onInputChange={(event, newInputValue) => {
                                    if (newInputValue?.length >= 3) {
                                        // Call your API here with the search key
                                        setsearchKey(newInputValue);
                                    }
                                }}
                                componentsProps={{ popper: { style: { width: '40dvw' } } }}
                                renderOption={(props, item) => {
                                    let serviceName = `${item?.service_name && item?.service_code ? `${item?.service_name} (${item?.service_code})` : item?.service_name}`
                                    let depart = `${item?.service_head && item?.service_head_code ? `${item?.service_head} (${item?.service_head_code})` : item?.service_head}`
                                    return (
                                        <Box {...props} key={item?.id} >
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignContent: "flex-start" }}>
                                                <Box display={'flex'}>
                                                    {serviceName?.length > 80 ?
                                                        <Tooltip placement='top' title={serviceName}>
                                                            <Typography sx={{ fontSize: "0.9vw", fontWeight: 600 }}>{serviceName?.slice(0, 77) + '... '}</Typography>
                                                        </Tooltip> : <Typography sx={{ fontSize: "0.9vw", fontWeight: 600 }}>{serviceName + ' '}</Typography>}
                                                </Box>
                                                {depart?.length > 80 ?
                                                    <Tooltip placement='top' title={depart}>
                                                        <Typography sx={{ fontSize: "0.8vw" }}>{depart?.slice(0, 77) + '...'}</Typography>
                                                    </Tooltip> : <Typography sx={{ fontSize: "0.8vw" }}>{depart}</Typography>}
                                            </Box>
                                        </Box>
                                    )
                                }}
                            />

                            {<Box component={'div'} border={'1px solid lightgray'} borderRadius={'5px'} height={'5.3dvh'}
                                    display={'flex'} alignItems={'center'} justifyContent={'space-evenly'} width={'6dvw'}>
                                    <IconButton
                                        sx={{ height: '4.5dvh', width: '2dvw' }}
                                        disabled={(+formState?.service_data?.unit === 1) || !formState?.service_data?.edit_unit || formState?.fromOrderSummary || formState?.PatientData?.is_final_bill_initiated || loginInfo?.module_name === "Investigation"}
                                        onClick={() => onClickUnitHandler('decrease')}
                                    ><RemoveIcon color={((+formState?.service_data?.unit === 1) || !formState?.service_data?.edit_unit || formState?.fromOrderSummary || formState?.PatientData?.is_final_bill_initiated || loginInfo?.module_name === "Investigation") ? 'disabled' : 'primary'} /></IconButton>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={COMMON_STYLES.FONT_WEIGHT}>{formState?.service_data?.unit}</Typography>
                                    <IconButton
                                        disabled={!formState?.service_data?.edit_unit || formState?.fromOrderSummary || formState?.PatientData?.is_final_bill_initiated || loginInfo?.module_name === "Investigation"}
                                        sx={{ height: '4.5dvh', width: '2dvw' }}
                                        onClick={() => onClickUnitHandler('increase')}
                                    ><AddIcon color={(!formState?.service_data?.edit_unit || formState?.fromOrderSummary || formState?.PatientData?.is_final_bill_initiated || loginInfo?.module_name === "Investigation") ? 'disabled' : 'primary'} /></IconButton>
                                </Box>}

                            {AmountViewAccess ?
                                (!!formState?.service_data?.doctor_amt || !!formState?.service_data?.hospital_amt || !!formState?.service_data?.is_sharable) ?
                                    <Button className='Common_Btn_Min_Width' sx={{ textTransform: 'capitalize' }}
                                        disabled={!formState?.service_data?.edit_amount}
                                        endIcon={`(${CommonValidation.formatAmount(formState?.service_data?.rate_per_unit)})`}
                                        onClick={() => onOpenPopupHandler('rate')}
                                    >Rate/Unit</Button> :
                                    <TextField
                                        autoComplete='off'
                                        size='small'
                                        InputProps={{ emed_tid: 'rte_unit', readOnly: !formState?.service_data?.edit_amount }}
                                        sx={{ width: '7dvw' }}
                                        label='Rate/Unit'
                                        value={formState?.service_data?.rate_per_unit}
                                        onChange={(e) => { withOutShareHandler(e, 'rate_per_unit') }}
                                    />
                                : null}

                            {AmountViewAccess ?
                                <Box component={'div'} display={'flex'}>
                                    {(!!formState?.service_data?.doctor_amt || !!formState?.service_data?.hospital_amt || !!formState?.service_data?.is_sharable) ?
                                        <Button className='Common_Btn_Min_Width' sx={{ textTransform: 'capitalize' }}
                                            disabled={!formState?.service_data?.edit_discount}
                                            endIcon={`(${CommonValidation.formatAmount(formState?.service_data?.concession_amt)})`}
                                            onClick={() => onOpenPopupHandler('concession')}
                                        >Concession</Button>
                                        :
                                        <><TextField
                                            disabled={!formState?.service_data?.edit_discount || formState?.service_data?.membership_discount_percentage}
                                            autoComplete='off'
                                            size='small'
                                            InputProps={{ emed_tid: 'con_amt' }}
                                            sx={{ width: '7dvw' }}
                                            label={`Concession (${CurrencySymbol})`}
                                            value={+formState?.service_data?.concession_amt ? formState?.service_data?.concession_amt : ""}
                                            onChange={(e) => { withOutShareHandler(e, 'concession_discount_amt') }}
                                        />
                                            <TextField
                                                disabled={!formState?.service_data?.edit_discount || formState?.service_data?.membership_discount_percentage}
                                                autoComplete='off'
                                                size='small'
                                                InputProps={{ emed_tid: 'con_per' }}
                                                sx={{ width: '7dvw' }}
                                                label={`Concession (%)`}
                                                value={+formState?.service_data?.concession_percent_w_r ? formState?.service_data?.concession_percent_w_r : ""}
                                                onChange={(e) => { withOutShareHandler(e, 'concession_discount_percent') }}
                                            /></>}
                                </Box>
                                : null}

                            {AmountViewAccess ? <Box component={'div'}>
                                <TextField
                                    size='small'
                                    sx={{ width: '9dvw' }}
                                    value={formState?.service_data?.total_amt ? CommonValidation.formatAmount((+formState?.service_data?.total_amt) - (+formState?.service_data?.concession_amt || 0)) : ''}
                                    InputProps={{ emed_tid: 'tlt', readOnly: true }}
                                    label='Total'
                                />
                            </Box> : null}

                            {userAccess?.editAccess && <IconButton
                                disabled={!formState.selected_bill_doc || !formState.selected_service}
                                sx={{ height: '2dvw', width: '2.5dvw' }}
                                onClick={() => onAddHandler()}
                            ><AddBoxIcon sx={{ height: '3dvw', width: '2.7dvw' }} color={!formState.selected_bill_doc || !formState.selected_service ? 'disabled' : 'primary'} />
                            </IconButton>}
                        </Box>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    useEffect(() => {
        const handler = setTimeout(() => {
            if (ServiceCount && searchKey?.length >= 3) {
                getServiceListData(searchKey);
            } else if (ServiceCount && !searchKey) {
                setformState((prev) => ({ ...prev, serviceSugg: [] }))
            }
        }, 500);
        return () => clearTimeout(handler);
    }, [searchKey, ServiceCount]);

    const popClose = () => {
        setIsWarning(false)
        settempDup([])
        setDuplicateIds([])
        setDialogOpen(false)
    }

    const confirmRemove = () => {
        setIsWarning(false);
        setformState((prev) => ({
            ...prev,
            orderList: [...prev.orderList, ...tempDup],
        }));
    };

    return (
        <Box sx={{ backgroundColor: Colors.ComponentBgColor, height: "74vh" }}>
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: 'flex-end', justifyContent: "space-between" }}>
                {Object.keys(PatientDetails)?.length === 0 ? null : <Box sx={{ backgroundColor: "white", display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'center', marginLeft: '0.5vw', padding: "0.5vw", marginTop: "0.3vw" }}>
                    <><Box>{renderPatientCard(PatientDetails)}</Box>
                        <Box>{renderPatientCard(PatientDetails, 'consultant')}</Box></>
                </Box>}
            </Box>
            <Box>{renderTable()}</Box>
            {userAccess?.editAccess &&             
            <Box component="div" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginRight: "0.75vw", marginTop: loginInfo?.module_name === 'Radiology' ? '0vw' : "0.5vw" }}>
                <Typography sx={{ fontSize: "0.95vw", fontWeight: 800, display: (formState?.patientData?.doctor_id || !formState?.patientData?.is_final_bill_initiated) ? "block" : "none", marginLeft: "0.75vw" }}>
                    Net Amount: {CommonValidation.formatAmount(netAmount)}
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Button
                    variant="outlined"
                    onClick={() => { handleClear() }}
                    sx={{ textTransform: "capitalize", mr: '0.5vw', width: "7vw" }}
                    size="small"
                >
                    {"Clear"}
                </Button>
                <Button
                    disabled={formState.selected_service || formState.orderList.some(isDuplicateRow) || (isMandatoryConcessionRemarksEnabled() && formState?.orderList?.some(item => (+item?.concession_amt || 0) > 0 && !((item?.individual_concession_comments || '').trim())))}
                    variant='contained'
                    onClick={() => { postOrderDetails() }}
                    sx={{ textTransform: "capitalize", width: "7vw" }}
                    size="small"
                >
                    {"Order"}
                </Button>
                </Box>
            </Box>}
            <Loader loaderOpen={isLoader} />
            {TimePopup()}
            {PopoverBox()}
            {renderConcessionRemarksDialog()}
            {errorMsg && <ToastMsg severity={'error'} msg={errorMsgText} msgPop={msgClose} />}
            {successMsg && <ToastMsg severity={'success'} msg={successMsgText} msgPop={msgClose} />}
            {IsWarning ? <ConfirmPopup
                cnfTitle={'Confirmation'}
                cnfContent={"Some services in the template already exist in the order list. Do you want to Continue?"}
                cnfAlertPopupClose={popClose.bind(this)}
                cnfData={confirmRemove.bind(this)}
            /> : null}
        </Box>
    );
};

export default LabCreateOrder;